import * as classnames from 'classnames'
import * as React from 'react'

import { ISeoItem } from '../../../../../typings/seoMetadata'

import * as styles from './sectionDescription.module.css'

const SectionDescription = ({
  children,
  metadata,
  HTag,
  hideOnMobile
}: {
  children?: any
  metadata: ISeoItem
  HTag: string
  hideOnMobile?: boolean
}) => {
  const rootClassNames = classnames({
    [styles.hideOnMobile]: hideOnMobile
  })
  return (
    <div className={rootClassNames}>
      <HTag className={styles.centralHeading}>{metadata.heading}</HTag>
      <p className={styles.centralBody}>{metadata.sub_heading}</p>
      {children && <div className={styles.centralSection}>{children}</div>}
    </div>
  )
}

export default SectionDescription
